module.exports = __webpack_public_path__ + "static/img/brand-5.126362f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/brand-5.png
// module id = 3ucc
// module chunks = 0